var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "main-body"
  }, [_c('h1', [_vm._v("注册")]), _c('Divider'), _c('Form', {
    ref: "formItem",
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "名字",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入名字"
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入手机号"
    },
    model: {
      value: _vm.formItem.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "mobile", $$v);
      },
      expression: "formItem.mobile"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "输入密码"
    },
    model: {
      value: _vm.formItem.password,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "password", $$v);
      },
      expression: "formItem.password"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "代码",
      "prop": "registerCode"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入代码"
    },
    model: {
      value: _vm.formItem.registerCode,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "registerCode", $$v);
      },
      expression: "formItem.registerCode"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("下一步")])], 1)], 1), _c('router-link', {
    staticClass: "signup-button",
    attrs: {
      "to": "/login"
    }
  }, [_c('a', [_vm._v("已有账号？点击登陆")])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }